"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("@celo/utils");
function invalidChain(chain) {
    return chain !== 'celo' && chain !== 'eip155';
}
// celo:0x123
function parseShortNameAddress(addressLike) {
    var _a = addressLike.split(':'), celo = _a[0], address = _a[1];
    if (invalidChain(celo) || !utils_1.AddressUtils.isValidAddress(address)) {
        throw new Error('Invalid short name address');
    }
    // default to mainnet
    return { address: address, networkId: '42220' };
}
// <address>@<chain>:<network_id>
// 0x123@celo:1234
// 0x123@eip155:1234
function parseCaip50Address(addressLike) {
    var _a = addressLike.split(/[@:]/), address = _a[0], chain = _a[1], networkId = _a[2];
    if (!utils_1.AddressUtils.isValidAddress(address) || invalidChain(chain)) {
        throw new Error("Invalid CAIP50 address " + address);
    }
    return { address: address, networkId: networkId };
}
// <chain>:<network_id>:<address>
// celo:1234:0x123
// eip155:1234:0x123
function parseCaip10Address(addressLike) {
    var _a = addressLike.split(':'), chain = _a[0], networkId = _a[1], address = _a[2];
    if (!utils_1.AddressUtils.isValidAddress(address) || invalidChain(chain)) {
        throw new Error("Invalid CAIP10 address " + address);
    }
    return { address: address, networkId: networkId };
}
function parseAddress(addressLike) {
    var lastError = null;
    for (var _i = 0, _a = [parseCaip10Address, parseCaip50Address, parseShortNameAddress]; _i < _a.length; _i++) {
        var parse = _a[_i];
        try {
            return parse(addressLike);
        }
        catch (e) {
            lastError = e;
        }
    }
    throw lastError;
}
exports.parseAddress = parseAddress;
//# sourceMappingURL=parse-addresses.js.map